var __TEMP__ = require('./_baseGetAllKeys.js');var baseGetAllKeys = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getSymbols.js');var getSymbols = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./keys.js');var keys = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getAllKeys;
